"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTokenUser = getTokenUser;
exports.getMyBookingToken = getMyBookingToken;
exports.signIn = signIn;
exports.logout = logout;
exports.register = register;
exports.socialAuth = socialAuth;
exports.facebookLogin = facebookLogin;
exports.googleLogin = googleLogin;
exports.appleLogin = appleLogin;
exports.resetPassword = resetPassword;
exports.Endpoint = void 0;
require("isomorphic-fetch");
var _format = _interopRequireDefault(require("date-fns/format"));
var _queryString = _interopRequireDefault(require("query-string"));
var _cookies = require("@kiwicom/cookies");
var _User = require("../../records/User");
var _config = _interopRequireDefault(require("../../consts/config"));
var _handlers = require("../fetch/handlers");
var _headers = require("../fetch/headers");
var _getOAuthRedirectUrl = _interopRequireDefault(require("./services/getOAuthRedirectUrl"));
var _getTokenUserQuery = _interopRequireDefault(require("../../graphql/account/queries/getTokenUserQuery"));
var _handleAffiliateId = _interopRequireDefault(require("../utils/handleAffiliateId"));
var _utils = require("./services/utils");
var session = _interopRequireWildcard(require("../session/session"));
var _session2 = require("../../consts/session");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
let Endpoint;
exports.Endpoint = Endpoint;
(function (Endpoint) {
  Endpoint["PLEXUS"] = "plexus";
  Endpoint["TEQUILA"] = "tequila";
})(Endpoint || (exports.Endpoint = Endpoint = {}));
const ENDPOINTS = {
  [Endpoint.PLEXUS]: _config.default.accountApiUrl,
  [Endpoint.TEQUILA]: "https://api.tequila.kiwi.com/kiwi-mmb/graphql"
};
async function getTokenUser(token, endpoint = Endpoint.PLEXUS) {
  var _load;
  const response = await fetch(ENDPOINTS[endpoint], {
    method: "POST",
    headers: {
      ..._headers.JSON_BOTH,
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      query: _getTokenUserQuery.default
    })
  }).then(res => res.json()).catch(() => Promise.reject(new Error("API error when retrieving user.")));
  if (response.data === null) {
    return Promise.reject(new Error("API error when retrieving user"));
  }
  const user = await (0, _User.mapAccountUser)(response.data);
  (0, _handleAffiliateId.default)(user.affiliateId);
  (0, _utils.identifyExponeaUser)(user.email, (_load = (0, _cookies.load)(_cookies.Cookie.USER_ID)) !== null && _load !== void 0 ? _load : "");
  session.save(_session2.ACCOUNT_ID, user.id);
  session.save(_session2.EMAIL, user.email);
  return user;
}
function getMyBookingToken({
  bid,
  email,
  iata,
  departure
}) {
  const query = {
    email,
    src: iata,
    dtime: (0, _format.default)(departure, _config.default.apiDateFormat)
  };
  return fetch(`${_config.default.bookingApiUrl}/api/v0.1/users/get_simple_token/${bid}?${_queryString.default.stringify(query)}`).then(res => {
    if (!res.ok) {
      return res.json().then(body => Promise.reject(new Error(body.msg)));
    }
    return res.json().then(body => ({
      token: body.simple_token,
      bid: Number(bid)
    }));
  });
}
async function signIn(input, endpoint = Endpoint.PLEXUS) {
  const res = await fetch(`${_config.default.apiAuthUrl}/v1/user.login`, {
    method: "POST",
    headers: (0, _headers.getBasicHeaders)(),
    body: JSON.stringify({
      login: input.email,
      password: input.password,
      brand: input.brand
    })
  }).then(res => (0, _handlers.handleJSON)(res));
  if (res.locks && res.locks.length > 0) {
    return Promise.reject(new Error("User is locked"));
  }
  const user = await getTokenUser(res.token, endpoint);
  return {
    type: "user",
    user,
    token: res.token
  };
}
function logout(token) {
  return fetch(`${_config.default.apiAuthUrl}/v1/user.logout`, {
    method: "POST",
    headers: (0, _headers.getAuthHeaders)(token),
    body: JSON.stringify(token)
  }).then(_handlers.handleError)
  // doesnt return anything because there is no server response
  .then(() => {});
}
function register(brand, input) {
  return fetch(`${_config.default.apiAuthUrl}/v1/user.save`, {
    method: "POST",
    headers: (0, _headers.getBasicHeaders)(),
    body: JSON.stringify({
      email: input.email,
      first_name: input.firstName,
      last_name: input.lastName,
      login: input.email,
      password: input.password,
      brand
    })
  }).then(_handlers.handleError);
}
/* eslint-enable babel/camelcase */

async function socialAuth(provider, url) {
  const res = await fetch(`${_config.default.apiAuthUrl}/v1/oauth.getAuthorizationUrl`, {
    method: "POST",
    headers: _headers.JSON_BOTH,
    body: JSON.stringify({
      provider_id: provider,
      app_id: _config.default.userAppAppId,
      redirect_url: (0, _getOAuthRedirectUrl.default)(url)
    })
  }).then(res => (0, _handlers.handleJSON)(res));
  return res.authorization_url;
}
function facebookLogin(accessToken) {
  const payload = {
    access_token: accessToken
  };
  return fetch(`${_config.default.apiAuthUrl}/v1/oauth.facebook.connect`, {
    method: "POST",
    headers: (0, _headers.getBasicHeaders)(),
    body: JSON.stringify(payload)
  }).then(response => (0, _handlers.handleJSON)(response));
}
function googleLogin(accessToken) {
  const payload = {
    access_token: accessToken
  };
  return fetch(`${_config.default.apiAuthUrl}/v1/oauth.google.connect`, {
    method: "POST",
    headers: (0, _headers.getBasicHeaders)(),
    body: JSON.stringify(payload)
  }).then(response => (0, _handlers.handleJSON)(response));
}
function appleLogin(idToken) {
  const payload = {
    id_token: idToken
  };
  return fetch(`${_config.default.apiAuthUrl}/v1/oauth.apple.connect`, {
    method: "POST",
    headers: (0, _headers.getBasicHeaders)(),
    body: JSON.stringify(payload)
  }).then(response => (0, _handlers.handleJSON)(response));
}
function resetPassword(email, brandId) {
  return fetch(`${_config.default.apiAuthUrl}/v1/user.resetPassword`, {
    method: "POST",
    headers: (0, _headers.getBasicHeaders)(),
    body: JSON.stringify({
      login: email,
      brand: brandId
    })
  }).then(_handlers.handleJSON);
}